import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

const Login = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-black flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="bg-gray-50 dark:bg-gray-900 rounded-2xl p-10 border border-gray-200 dark:border-gray-800">
          <div className="text-center mb-8">
            <Zap size={40} className="text-primary-500 mx-auto mb-6" />
            <h2 className="text-4xl font-black mb-3 text-gray-900 dark:text-white">Welcome Back</h2>
            <p className="text-gray-600 dark:text-gray-400 text-lg">
              Log in to continue your learning journey
            </p>
          </div>
          
          <form className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="input w-full"
                placeholder="you@example.com"
              />
            </div>
            
            <div>
              <label htmlFor="password" className="block text-sm font-semibold text-gray-900 dark:text-white mb-2">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="input w-full"
                placeholder="••••••••"
              />
            </div>
            
            <button type="submit" className="btn-primary w-full">
              Log In
            </button>
          </form>
          
          <div className="mt-8 text-center">
            <p className="text-gray-600 dark:text-gray-400">
              Don't have an account?{' '}
              <Link to="/register" className="text-primary-500 hover:text-primary-600 font-semibold">
                Sign up free
              </Link>
            </p>
          </div>
          
          <p className="text-sm text-gray-500 dark:text-gray-500 mt-6 text-center">
            Authentication to be fully implemented in later phases.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;




